<template>
  <b-card no-body class="tachograph-driver-view">
    <b-modal id="day-detail" size="lg" body-class="p-0" title="Takograf Sürücü Gün Detayları" scrollable hide-footer no-close-on-esc no-close-on-backdrop>
      <tachograph-driver-day-detail ref="dayDetail" :detail="currentDayDetail" :display-mode="displayMode"></tachograph-driver-day-detail>
    </b-modal>

    <b-modal id="upload" :size="(details || []).length !== 0 ? 'lg' : 'md'" title="Takograf Verilerini Yükle" scrollable no-close-on-esc no-close-on-backdrop>
      <upload-tachograph-driver v-model="tachograph" :details="details"></upload-tachograph-driver>
      <template #modal-footer>
        <v-executer :disabled="tachograph.Files.length === 0" :loading="loading" :text="loading ? 'Dosyalar işleniyor... Bu işlem uzun sürebilir.' : 'Yükle'" :action="upload"></v-executer>
      </template>
    </b-modal>

    <v-table ref="table" with-items :items="filteredItems" name="tachograph-driver-operations" :excel-callback="getExcel" pagination="client" :settings="false" v-on:component-action="onDayDetail" :fields="fields">
      <template #additional-thead>
        <tr v-if="c_hasTotal">
          <th></th>
          <th class="v-table-column-sticky align-middle">{{ c_month }} {{ showingYear }}</th>
          <th class="align-middle text-center"><span class="font-weight-bolder text-info"><short-text text="Aylık Toplam Kilometre" custom="ATKM"></short-text></span><br/>{{ $safe(monthlyTotal,'MonthlyTotalKm') }}</th>
          <th class="align-middle text-center drive-column-header"><span class="font-weight-bolder text-success"><short-text text="Aylık Toplam Sürüş Zamanı"></short-text></span><br/>{{ $safe(monthlyTotal,'MonthlyTotalDrivingTime') }}</th>
          <th class="align-middle text-center"><span class="font-weight-bolder text-primary"><short-text text="Aylık Toplam Rölanti Zamanı"></short-text></span><br/>{{ $safe(monthlyTotal,'MonthlyTotalWorkingTime') }}</th>
          <th class="align-middle text-center">
            <span class="font-weight-bolder text-secondary night-stat-label">
              <feather-icon icon="MoonIcon" size="13" class="mr-25"></feather-icon>
              <short-text text="Aylık Toplam Gece Çalışma Zamanı"></short-text>
            </span><br/>{{ $safe(monthlyTotal,'MonthlyTotalNightWorkingTime') }}
          </th>
          <th class="align-middle text-center"><span class="font-weight-bolder text-warning"><short-text text="Aylık Toplam Çalışılabilir Zaman"></short-text></span><br/>{{ $safe(monthlyTotal,'MonthlyTotalAvailableTime') }}</th>
          <th class="align-middle text-center"><span class="font-weight-bolder text-danger"><short-text text="Aylık Toplam Dinlenme Zamanı"></short-text></span><br/>{{ $safe(monthlyTotal,'MonthlyTotalRestTime') }}</th>
          <th class="align-middle text-center"><span class="font-weight-bolder text-muted"><short-text text="Aylık Toplam Bilinmeyen Zaman"></short-text></span><br/>{{ $safe(monthlyTotal,'MonthlyTotalUnknownTime') }}</th>
          <template v-for="(total,index) in totals">
            <td class="text-center" :key="'DTKM'+index"><span class="font-weight-bolder text-info"><short-text text="Günlük Toplam Kilometre" custom="GTKM"></short-text></span><br/>{{ total.DailyTotalKm || '-' }}</td>
            <td class="text-center drive-column-cell" :key="'DTDT'+index"><span class="font-weight-bolder text-success"><short-text text="Günlük Toplam Sürüş Zamanı"></short-text></span><br/>{{ total.DailyTotalDrivingTime || '-' }}</td>
            <td class="text-center" :key="'DTWT'+index"><span class="font-weight-bolder text-primary"><short-text text="Günlük Toplam Rölanti Zamanı"></short-text></span><br/>{{ total.DailyTotalWorkingTime || '-' }}</td>
            <td class="text-center" :key="'DTNWT'+index">
              <span class="font-weight-bolder text-secondary night-stat-label">
                <feather-icon icon="MoonIcon" size="13" class="mr-25"></feather-icon>
                <short-text text="Günlük Toplam Gece Çalışma Zamanı"></short-text>
              </span><br/>{{ total.DailyNightWorkingTime || '-' }}
            </td>
            <td class="text-center" :key="'DTAT'+index"><span class="font-weight-bolder text-warning"><short-text text="Günlük Toplam Çalışılabilir Zaman"></short-text></span><br/>{{ total.DailyTotalAvailableTime || '-' }}</td>
            <td class="text-center" :key="'DTRT'+index"><span class="font-weight-bolder text-danger"><short-text text="Günlük Toplam Dinlenme Zamanı"></short-text></span><br/>{{ total.DailyTotalRestTime || '-' }}</td>
            <td class="text-center" :key="'DTUT'+index"><span class="font-weight-bolder text-muted"><short-text text="Günlük Toplam Bilinmeyen Zaman"></short-text></span><br/>{{ total.DailyUnknownTime || '-' }}</td>
            <td :key="'DTD'+index"></td>
          </template>
        </tr>
        <tr v-if="c_hasTotal"><th colspan="1500"></th></tr>
      </template>

      <template #additional-actions>
        <div class="tachograph-toolbar">
          <div class="tachograph-toolbar__head">
            <div class="tachograph-toolbar__head-main">
              <div class="tachograph-toolbar__summary">
                <div class="tachograph-toolbar__eyebrow"><feather-icon icon="ActivityIcon" size="14" class="mr-50"></feather-icon>Takograf sürücü zaman analizi</div>
                <div class="tachograph-toolbar__headline">Aylık akış, günlük toplamlar ve detay zamanı aynı modda okunur.</div>
                <p class="mb-0 text-muted tachograph-toolbar__hint">{{ displayModeHint }}</p>
              </div>
              <div class="tachograph-toolbar__chips">
                <span class="tachograph-chip"><feather-icon icon="CalendarIcon" size="13" class="mr-50"></feather-icon>{{ c_month }} {{ showingYear }}</span>
                <span class="tachograph-chip" :class="displayMode === 'utc_plus_3' ? 'tachograph-chip--accent' : 'tachograph-chip--info'">
                  <feather-icon :icon="displayMode === 'utc_plus_3' ? 'GlobeIcon' : 'ClockIcon'" size="13" class="mr-50"></feather-icon>{{ displayModeChipText }}
                </span>
                <span class="tachograph-chip tachograph-chip--neutral"><feather-icon icon="EyeIcon" size="13" class="mr-50"></feather-icon>{{ activeFilterCount }} alan gösteriliyor</span>
                <span v-if="displayMode === 'utc_plus_3'" class="tachograph-chip tachograph-chip--warning"><feather-icon icon="AlertCircleIcon" size="13" class="mr-50"></feather-icon>KM dağılımı yaklaşık yorumlanmalıdır</span>
              </div>
            </div>

            <div class="tachograph-toolbar__subline">
              <div class="tachograph-mode-inline" :class="displayMode === 'utc_plus_3' ? 'tachograph-mode-inline--utc3' : 'tachograph-mode-inline--utc'">
                <feather-icon :icon="displayMode === 'utc_plus_3' ? 'SunriseIcon' : 'ClockIcon'" size="14" class="mr-50"></feather-icon>
                <strong>{{ displayModeBannerTitle }}</strong>
                <span>{{ displayModeBannerText }}</span>
              </div>

              <div class="tachograph-legend">
                <div class="tachograph-legend__title">Kısaltmalar</div>
                <div class="tachograph-legend__items">
                  <span
                    v-for="item in legendItems"
                    :key="item.key"
                    class="tachograph-legend__item"
                    :class="item.className"
                  >
                    <span class="tachograph-legend__abbr">
                      <feather-icon v-if="item.icon" :icon="item.icon" size="12" class="mr-25"></feather-icon>{{ item.key }}
                    </span>
                    <span>{{ item.text }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="tachograph-toolbar__body">
            <div class="tachograph-panel">
              <div class="tachograph-panel__title"><feather-icon icon="SearchIcon" size="15" class="mr-50 text-success"></feather-icon>Sorgu aralığı</div>
              <small class="text-muted d-block mb-75">Ay ve yıl seçimini değiştirip tabloyu yenileyin.</small>
              <div class="tachograph-panel__row">
                <select class="form-control" v-model="month"><option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option></select>
                <select class="form-control" v-model="year"><option v-for="y in years" :key="y" :value="y">{{y}}</option></select>
                <button class="btn btn-success" v-on:click="getTachograph"><feather-icon icon="RefreshCwIcon" size="14" class="mr-50"></feather-icon>Sorgula</button>
              </div>
            </div>

            <div class="tachograph-panel">
              <div class="tachograph-panel__title"><feather-icon icon="ClockIcon" size="15" class="mr-50 text-primary"></feather-icon>Gösterim modu</div>
              <small class="text-muted d-block mb-75">{{ displayModePanelDescription }}</small>
              <select class="form-control mb-75" v-model="displayMode">
                <option v-for="option in displayModeOptions" :key="option.value" :value="option.value">{{ option.text }}</option>
              </select>
              <div class="tachograph-panel__note"><feather-icon icon="InfoIcon" size="13" class="mr-50"></feather-icon>{{ displayModePanelFootnote }}</div>
            </div>

            <div class="tachograph-panel">
              <div class="tachograph-panel__title"><feather-icon icon="SlidersIcon" size="15" class="mr-50 text-warning"></feather-icon>Hızlı işlemler</div>
              <small class="text-muted d-block mb-75">Yükleme ve kolon filtresi aynı alanda.</small>
              <div class="tachograph-panel__stack">
                <div class="tachograph-search">
                  <feather-icon icon="SearchIcon" size="14" class="tachograph-search__icon"></feather-icon>
                  <input v-model="searchTerm" type="text" class="form-control tachograph-search__input" placeholder="Sürücü, kart no veya süre ara...">
                </div>
                <button class="btn btn-primary" v-on:click="openUplaoder"><feather-icon icon="UploadCloudIcon" size="14" class="mr-50"></feather-icon>Takograf verilerini yükle</button>
                <b-dropdown variant="outline-dark" class="w-100">
                  <template #button-content><feather-icon icon="FilterIcon" class="mr-50"></feather-icon>Filtrele</template>
                  <div class="pr-50 pl-50">
                    <div class="p-25" v-for="f in filters" :key="f.key">
                      <b-form-checkbox :disabled="f.value === true && c_onlyOneFilterDisabled" v-on:change="filterData(f.key,$event)" class="text-nowrap" v-model="f.value"><span class="font-weight-bolder" :class="f.variant">{{f.key}}</span> - {{f.text}}</b-form-checkbox>
                    </div>
                  </div>
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #information>
        <div class="tachograph-information">
          <span><b>'-'</b> ifadesi o gün için kayıt olmadığını gösterir.</span>
          <span>{{ displayModePanelFootnote }}</span>
          <span v-if="displayMode === 'utc_plus_3'" class="text-warning font-weight-bolder">KM bilgisi UTC+3 modunda gün bazında birebir ayrışamayabilir.</span>
          <span>Detay ekranındaki zaman akışı da aynı moda göre yeniden hesaplanır.</span>
        </div>
      </template>
    </v-table>
  </b-card>
</template>

<script>
import {BCard,BDropdown,BFormCheckbox} from 'bootstrap-vue'
import moment from 'moment'
import objectPath from 'object-path'
import EmployeeOperationsApi from '@/api/employee-operations'
import UploadTachographDriver from './components/UploadTachographDriver'
import Additional from '@/utilities/additional'
import ShortText from '@/components/ShortText.vue'
import TachographDriverDayDetail from './components/TachographDriverDayDetail.vue'

export default {
  components:{BCard,UploadTachographDriver,BDropdown,BFormCheckbox,ShortText,TachographDriverDayDetail},
  data(){
    return{
      month:null,showingMonth:null,years:[],year:null,showingYear:null,displayMode:'utc',
      displayModeOptions:[{ value:'utc', text:'UTC Gösterimi' },{ value:'utc_plus_3', text:'UTC+3 Gösterimi' }],
      items:[],totals:[],
      monthlyTotal:{MonthlyTotalAvailableTime:null,MonthlyTotalDrivingTime:null,MonthlyTotalNightWorkingTime:null,MonthlyTotalRestTime:null,MonthlyTotalWorkingTime:null},
      fields:[
        { name:'Sıra', key:'Order', tdClass:'text-center font-weight-bolder'},
        { name:'Sürücü Bilgisi',tdClass:'text-nowrap',key:'DriverFullName',sticky:true},
        { name:'TKM',tdClass:'text-nowrap font-weight-bolder border-right',key:'MonthlyTotalKm', tooltip:'Toplam Kilometre'},
        { name:'TSZ',tdClass:'text-nowrap font-weight-bolder border-right drive-column-cell',thClass:'drive-column-header',key:'MonthlyTotalDrivingTime', tooltip:'Toplam Sürüş Zamanı'},
        { name:'TRZ',tdClass:'text-nowrap font-weight-bolder border-right',key:'MonthlyTotalWorkingTime', tooltip:'Toplam Rölanti Zamanı'},
        { name:'TGCZ',tdClass:'text-nowrap font-weight-bolder border-right night-column-cell',thClass:'night-column-header',key:'MonthlyTotalNightWorkingTime', tooltip:'Toplam Gece Çalışma Zamanı', icon:'MoonIcon'},
        { name:'TCZ',tdClass:'text-nowrap font-weight-bolder border-right',key:'MonthlyTotalAvailableTime', tooltip:'Toplam Çalışılabilir Zaman'},
        { name:'TDZ',tdClass:'text-nowrap font-weight-bolder border-right',key:'MonthlyTotalRestTime', tooltip:'Toplam Dinlenme Zamanı'},
        { name:'TBZ',tdClass:'text-nowrap font-weight-bolder border-right',key:'MonthlyTotalUnknownTime', tooltip:'Toplam Bilinmeyen Zaman'},
      ],
      months:[{index:1,name:'Ocak'},{index:2,name:'Şubat'},{index:3,name:'Mart'},{index:4,name:'Nisan'},{index:5,name:'Mayıs'},{index:6,name:'Haziran'},{index:7,name:'Temmuz'},{index:8,name:'Ağustos'},{index:9,name:'Eylül'},{index:10,name:'Ekim'},{index:11,name:'Kasım'},{index:12,name:'Aralık'}],
      legendItems:[
        { key:'KM', text:'Kilometre', className:'tachograph-legend__item--km' },
        { key:'SZ', text:'Sürüş zamanı', className:'tachograph-legend__item--drive' },
        { key:'RZ', text:'Rölanti zamanı', className:'tachograph-legend__item--work' },
        { key:'GCZ', text:'Gece çalışma zamanı', className:'tachograph-legend__item--night', icon:'MoonIcon' },
        { key:'CZ', text:'Çalışılabilir zaman', className:'tachograph-legend__item--available' },
        { key:'DZ', text:'Dinlenme zamanı', className:'tachograph-legend__item--rest' },
        { key:'BZ', text:'Bilinmeyen zaman', className:'tachograph-legend__item--unknown' },
        { key:'Taşma', text:'Önceki günden gelen eksik gün uyarısı', className:'tachograph-legend__item--carry' },
      ],
      filters:[
        {key:'SZ',variant:'text-success',text:'Sürüş Zamanı',value:true},
        {key:'RZ',variant:'text-primary',text:'Rölanti Zamanı',value:true},
        {key:'GCZ',variant:'text-secondary',text:'Gece Çalışma Zamanı',value:true},
        {key:'CZ',variant:'text-warning',text:'Çalışılabilir Zaman',value:true},
        {key:'DZ',variant:'text-danger',text:'Dinlenme Zamanı',value:true},
        {key:'BZ',variant:'text-muted',text:'Bilinmeyen Zaman',value:true},
      ],
      loading:false,tachograph:{Files:[]},details:[],sideOpen:false,currentDayDetail:null,searchTerm:''
    }
  },
  mounted(){ this.getCurrentYear(); this.configureYears(); this.getCurrentMonth(); this.configureFields(Date.now()); this.getTachograph() },
  watch:{ displayMode(){ if(this.month != null && this.year != null){ this.getTachograph() } } },
  methods:{
    configureYears(){ let years=[]; let year=2015; while(year <= this.year){ years.push(year); year++ } this.years=years },
    getCurrentYear(){ this.year = moment().format('YYYY'); this.showingYear = this.year },
    getCurrentMonth(){
      let current = moment().month() + 1
      let matchedMonth = this.months.find(m=>m.index == current)
      this.month = matchedMonth ? matchedMonth.index : 0
      this.showingMonth = this.month
    },
    configureFields(date){
      this.fields = this.fields.filter(f=> !f.date)
      Array.from(Array(moment(date).daysInMonth()).keys()).forEach(d=>{
        let _date = moment(date).startOf('month').add(d,'days')
        let _dateForObject = _date.format('YYYY-MM-DD')
        let _dateForName = _date.locale('tr').format('DD.MM.YYYY ddd')
        this.fields.push({name:_dateForName,date:true,children:[
          { name:'KM', thClass:'text-info', tdClass:'km-column-cell', key:'Data.'+_dateForObject,tooltip:'Kilometre', component:true,componentOptions:{name:'tachograph-driver-day-km/TachographDriverDayKm'}},
          { name:'SZ', thClass:'text-success drive-column-header', tdClass:'drive-column-cell', key:'Data.'+_dateForObject+'.DrivingTime',tooltip:'Sürüş Zamanı'},
          { name:'RZ', thClass:'text-primary', key:'Data.'+_dateForObject+'.WorkingTime',tooltip:'Rölanti Zamanı'},
          { name:'GCZ', thClass:'text-secondary night-column-header', tdClass:'night-column-cell', key:'Data.'+_dateForObject+'.NightWorkingTime',tooltip:'Gece Çalışma Zamanı', icon:'MoonIcon'},
          { name:'CZ', thClass:'text-warning', key:'Data.'+_dateForObject+'.AvailableTime',tooltip:'Çalışılabilir Zaman'},
          { name:'DZ', thClass:'text-danger',key:'Data.'+_dateForObject+'.RestTime',tooltip:'Dinlenme Zamanı'},
          { name:'BZ', thClass:'text-muted',key:'Data.'+_dateForObject+'.UnknownTime',tooltip:'Bilinmeyen Zaman'},
          { name:'Detay',tdClass:'border-right text-center',key:'Data.'+_dateForObject,component:true,componentOptions:{name:'tachograph-driver-day-detail/TachographDriverDayDetail'}},
        ]})
      })
    },
    configureData(data){
      data.forEach(d=>{
        let currentDays = d.Data.reduce((object,dt)=>{
          let days = Object.keys(dt).filter(k=> k != 'DriverFullName')
          days.forEach(day=>{
            let value = dt[day]
            if(value && typeof value === 'object' && !Array.isArray(value)){
              Object.assign(value,{ DisplayMode:this.displayMode })
            }
            Object.assign(object,{[day]:value})
          })
          return object
        },{})
        d.Data = currentDays
      })
      return data
    },
    configureTotalData(data){
      let resultData=[]; let date = moment(this.year+'-'+this.month,'YYYY-MM')
      Array.from(Array(moment(date).daysInMonth()).keys()).forEach(d=>{
        let _date = moment(date).startOf('month').add(d,'days').format('DD.MM.YYYY')
        let item = data.find(x=>x.Date == _date)
        let resultItem = { DailyTotalAvailableTime:null, DailyTotalDrivingTime:null, DailyTotalRestTime:null, DailyTotalWorkingTime:null, DailyNightWorkingTime:null, Date:_date }
        if(item){ resultItem.DailyTotalAvailableTime=item.DailyTotalAvailableTime; resultItem.DailyTotalDrivingTime=item.DailyTotalDrivingTime; resultItem.DailyTotalRestTime=item.DailyTotalRestTime; resultItem.DailyTotalWorkingTime=item.DailyTotalWorkingTime; resultItem.DailyNightWorkingTime=item.DailyNightWorkingTime; resultItem.DailyUnknownTime=item.DailyUnknownTime; resultItem.DailyTotalKm=item.DailyTotalKm }
        resultData.push(resultItem)
      })
      return resultData
    },
    getTachograph(){
      this.$refs.table.setLoading(true)
      EmployeeOperationsApi.Tachograph.MonthlyDrivingTime(this.month,this.year,this.displayMode).then(res=>{
        let date = moment(this.year+'-'+this.month,'YYYY-MM')
        this.configureFields(date)
        this.showingMonth = this.month
        this.showingYear = this.year
        this.items = this.configureData(res.data.resData)
        this.totals = this.configureTotalData(res.data.dailyData)
        this.monthlyTotal = res.data.monthlyTotalSumByActivityType[0]
        this.$refs.table.setLoading(false)
      }).catch(()=>{ this.$refs.table.setLoading(false) })
    },
    clearForm(){ this.tachograph.Files=[]; this.details=[] },
    openUplaoder(){ this.clearForm(); this.$showModal('upload') },
    async upload(){
      this.loading = true
      let formData = await Additional.ToFormData(this.tachograph)
      this.details = []
      EmployeeOperationsApi.Tachograph.UploadFile(formData).then(res=>{
        this.details = res.data.Data
        this.loading = false
        if(!res.data.Success){ this.$result(res) }
        this.getTachograph()
      }).catch(err=>{ this.loading = false; this.$result(null,err) })
    },
    getExcel(){
      this.$refs.table.setExcelLoading(true)
      EmployeeOperationsApi.Tachograph.ExcelExport(this.month,this.year).then(res=>{
        Additional.DownloadFile(res.data,'Takograf.xlsx')
        this.$refs.table.setExcelLoading(false)
      }).catch(err=>{ this.$result(null,err); this.$refs.table.setExcelLoading(false) })
    },
    filterData(key,e){ this.$refs.table.dataVisibility('name',key,e) },
    onDayDetail(e){
      this.currentDayDetail = null
      this.currentDayDetail = {
        ...e,
        displayDate:(e && e.DisplayDate) || (e && e.displayDate) || null
      }
      this.$showModal('day-detail')
    }
  },
  computed:{
    displayModeHint(){ return this.displayMode === 'utc_plus_3' ? '01.03.2026 ve sonrası kayıtlar UTC+3 gün sınırına göre yeniden hesaplanır.' : 'Tüm kayıtlar ham UTC gününe göre gösterilir.' },
    displayModeChipText(){ return this.displayMode === 'utc_plus_3' ? 'UTC+3 aktif' : 'UTC aktif' },
    displayModeBannerTitle(){ return this.displayMode === 'utc_plus_3' ? 'UTC+3 görünümü günlük sınırı değiştirir' : 'UTC görünümü ham takograf gününü korur' },
    displayModeBannerText(){ return this.displayMode === 'utc_plus_3' ? '21:00 UTC sonrası aktiviteler ertesi yerel güne taşınır. Günlük toplamlar, detay akışı ve kısmi taşmalar birlikte yeniden hesaplanır.' : 'Aylık toplamlar ve detay zaman akışı veritabanındaki UTC gün kırılımıyla birebir gösterilir.' },
    displayModePanelDescription(){ return this.displayMode === 'utc_plus_3' ? 'Gün kırılımı 21:00 UTC sonrası aktiviteleri ertesi lokal güne taşır.' : 'Tüm süreler veritabanındaki UTC aktivite gününe göre okunur.' },
    displayModePanelFootnote(){ return this.displayMode === 'utc_plus_3' ? 'Detay modalında da aynı gün sınırı kullanılır. KM dağılımı yaklaşık yorumlanmalıdır.' : 'Detay ve aylık toplamlar ham UTC akışı ile uyumludur.' },
    activeFilterCount(){ return this.filters.filter(f=> f.value === true).length },
    filteredItems(){
      if(!this.searchTerm || !this.searchTerm.trim()){
        return this.items
      }

      const term = this.searchTerm.trim().toLowerCase()
      const fieldKeys = this.fields
        .flatMap(field => field.children ? field.children.map(child => child.key) : [field.key])
        .filter(Boolean)

      return this.items.filter(item => {
        const itemText = JSON.stringify(item)
        if(itemText && itemText.toLowerCase().includes(term)){
          return true
        }

        return fieldKeys.some(key => {
          const value = objectPath.get(item, key)
          return value != null && value.toString().toLowerCase().includes(term)
        })
      })
    },
    c_onlyOneFilterDisabled(){ return this.filters.filter(f=> f.value === true).length === 1 },
    c_month(){
      const matchedMonth = this.months.find(m=> m.index == this.showingMonth)
      return matchedMonth ? matchedMonth.name : ''
    },
    c_hasTotal(){ return this.totals.filter(t => t.DailyNightWorkingTime != null || t.DailyTotalAvailableTime != null || t.DailyTotalDrivingTime != null || t.DailyTotalRestTime != null || t.DailyTotalWorkingTime != null).length > 0 }
  }
}
</script>

<style scoped>
.tachograph-toolbar{display:grid;gap:.65rem;margin-bottom:.6rem}
.tachograph-toolbar__head{display:grid;gap:.55rem;padding:.8rem .95rem;border:1px solid rgba(15,23,42,.08);border-radius:.9rem;background:linear-gradient(135deg,rgba(15,23,42,.035),rgba(15,118,110,.05))}
.tachograph-toolbar__head-main{display:flex;align-items:flex-start;justify-content:space-between;gap:1rem}
.tachograph-toolbar__summary{min-width:0}
.tachograph-toolbar__eyebrow{display:inline-flex;align-items:center;padding:.28rem .55rem;border-radius:999px;background:rgba(255,255,255,.85);font-size:.72rem;font-weight:700;text-transform:uppercase}
.tachograph-toolbar__headline{margin-top:.45rem;font-weight:700;color:#334155;line-height:1.35}
.tachograph-toolbar__hint{margin-top:.2rem;font-size:.8rem}
.tachograph-toolbar__chips{display:flex;flex-wrap:wrap;justify-content:flex-end;gap:.4rem}
.tachograph-chip{display:inline-flex;align-items:center;padding:.34rem .58rem;border-radius:999px;background:rgba(255,255,255,.9);border:1px solid rgba(148,163,184,.22);font-size:.74rem;font-weight:700;line-height:1.1}
.tachograph-chip--accent{background:rgba(15,118,110,.12);color:#0f766e}
.tachograph-chip--info{background:rgba(37,99,235,.1);color:#1d4ed8}
.tachograph-chip--neutral{background:rgba(241,245,249,.95);color:#334155}
.tachograph-chip--warning{background:rgba(255,247,237,.95);color:#c2410c}
.tachograph-toolbar__subline{display:grid;grid-template-columns:minmax(240px,auto) minmax(0,1fr);gap:.65rem;align-items:center}
.tachograph-mode-inline{display:flex;align-items:center;gap:.45rem;padding:.48rem .7rem;border-radius:.8rem;border:1px solid rgba(148,163,184,.18);font-size:.76rem;line-height:1.3;color:#475569;background:rgba(255,255,255,.9)}
.tachograph-mode-inline strong{color:#1f2937;white-space:nowrap}
.tachograph-mode-inline span{min-width:0}
.tachograph-mode-inline--utc{background:linear-gradient(135deg,rgba(37,99,235,.06),rgba(255,255,255,.96));border-color:rgba(37,99,235,.12)}
.tachograph-mode-inline--utc3{background:linear-gradient(135deg,rgba(15,118,110,.07),rgba(255,247,237,.95));border-color:rgba(15,118,110,.16)}
.tachograph-legend{display:flex;align-items:center;gap:.55rem;min-width:0;padding:.45rem .6rem;border:1px dashed rgba(148,163,184,.28);border-radius:.8rem;background:rgba(248,250,252,.86)}
.tachograph-legend__title{flex:none;font-size:.7rem;font-weight:800;text-transform:uppercase;letter-spacing:.04em;color:#475569}
.tachograph-legend__items{display:flex;flex-wrap:nowrap;gap:.4rem;overflow-x:auto;padding-bottom:.15rem;min-width:0}
.tachograph-legend__item{display:inline-flex;align-items:center;gap:.35rem;padding:.28rem .5rem;border-radius:999px;border:1px solid transparent;background:#fff;font-size:.72rem;color:#475569;white-space:nowrap;flex:none}
.tachograph-legend__abbr{display:inline-flex;align-items:center;font-weight:800}
.tachograph-legend__item--km{border-color:rgba(8,145,178,.18);background:rgba(236,254,255,.95);color:#0e7490}
.tachograph-legend__item--drive{border-color:rgba(16,185,129,.18);background:rgba(240,253,244,.95);color:#047857}
.tachograph-legend__item--work{border-color:rgba(59,130,246,.18);background:rgba(239,246,255,.95);color:#1d4ed8}
.tachograph-legend__item--night{border-color:rgba(99,102,241,.18);background:rgba(238,242,255,.95);color:#4338ca}
.tachograph-legend__item--available{border-color:rgba(245,158,11,.18);background:rgba(255,251,235,.96);color:#b45309}
.tachograph-legend__item--rest{border-color:rgba(239,68,68,.16);background:rgba(254,242,242,.96);color:#b91c1c}
.tachograph-legend__item--unknown{border-color:rgba(148,163,184,.24);background:rgba(248,250,252,.96);color:#475569}
.tachograph-legend__item--carry{border-color:rgba(245,158,11,.22);background:rgba(255,247,237,.96);color:#b45309}
.night-stat-label{display:inline-flex;align-items:center;justify-content:center;color:#4338ca}
.tachograph-toolbar__body{display:grid;grid-template-columns:1.05fr 1.05fr 1fr;gap:.75rem}
.tachograph-panel{padding:.82rem;border:1px solid rgba(148,163,184,.18);border-radius:.9rem;background:#fff;box-shadow:0 8px 18px rgba(15,23,42,.04)}
.tachograph-panel__title{display:flex;align-items:center;font-weight:700;color:#111827;margin-bottom:.3rem}
.tachograph-panel__row{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr) auto;gap:.55rem}
.tachograph-panel__stack{display:grid;gap:.5rem}
.tachograph-panel__stack .btn,.tachograph-panel .dropdown{width:100%}
.tachograph-panel__note{display:inline-flex;align-items:center;padding:.42rem .58rem;border-radius:.7rem;background:#f8fafc;color:#475569;font-size:.76rem}
.tachograph-search{position:relative}
.tachograph-search__icon{position:absolute;left:.8rem;top:50%;transform:translateY(-50%);color:#64748b}
.tachograph-search__input{padding-left:2.25rem}
.tachograph-information{display:flex;flex-wrap:wrap;gap:.75rem 1rem;padding:.7rem .9rem;border-radius:.9rem;background:#f8fafc;border:1px solid rgba(148,163,184,.16);color:#475569}
@media (max-width:1399.98px){.tachograph-toolbar__head-main,.tachograph-toolbar__subline{grid-template-columns:1fr;display:grid}.tachograph-toolbar__chips{justify-content:flex-start}}
@media (max-width:1199.98px){.tachograph-toolbar__body{grid-template-columns:1fr}}
@media (max-width:767.98px){.tachograph-panel__row{grid-template-columns:1fr}}
</style>
<style>
.tachograph-driver-view .night-column-header{background:linear-gradient(180deg,rgba(49,46,129,.14),rgba(67,56,202,.08)) !important;color:#312e81 !important}
.tachograph-driver-view td.night-column-cell{background:linear-gradient(180deg,rgba(224,231,255,.78),rgba(238,242,255,.92)) !important;color:#312e81;font-weight:700;box-shadow:inset 1px 0 0 rgba(99,102,241,.14),inset -1px 0 0 rgba(99,102,241,.08)}
.tachograph-driver-view th.night-column-header .text-nowrap{color:#312e81 !important}
.tachograph-driver-view th.night-column-header span{color:#312e81 !important}
</style>
